import { Component } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { User } from '@app/_models';
import { AccountService, ConnectionService } from '@app/_services';
import { NgxSpinnerService } from 'ngx-spinner';
import { first } from 'rxjs/operators';
import { AlertService } from '../_services';

@Component({ templateUrl: 'home.component.html' })
export class HomeComponent {
  user: User;
  uid: string;
  auid: string;
  finaltoken: string;
  refereshToken: string;

  Dashboard: string;
  constructor(private accountService: AccountService, 
    private route: ActivatedRoute, 
    private alertService: AlertService, 
    private router: Router, 
    private connectionservice: ConnectionService, 
    private spinner: NgxSpinnerService) {
    this.user = this.accountService.userValue;
  }
  ngOnInit() {

    this.uid = localStorage.getItem("uid");
    this.auid = localStorage.getItem("auid");
    if (localStorage.getItem("uid")) {
      this.Dashboard = "Please wait authentication is in process";
      this.spinner.show();
      let URLAFTERTEAMS = "./connection/New/" + this.uid + "/" + localStorage.getItem("For") + "/" + this.auid;
      const isPublish=localStorage.getItem('IsPublish');
      if(isPublish && isPublish!=null){
        URLAFTERTEAMS="./connection/teams-action-auth/"+this.auid;
      }
      this.route.queryParams.subscribe(params => {
        this.refereshToken = params['code'];
        this.connectionservice.posteamOpenAuthentication(
          this.refereshToken,this.uid, this.auid, localStorage.getItem("client_id"), localStorage.getItem("clientsecret"), localStorage.getItem("TeamsReturnURL"))
          .pipe(first())
          .subscribe(
            data => {
              this.finaltoken = data;
              localStorage.clear();
              this.spinner.hide();
              this.alertService.success(data.message, { keepAfterRouteChange: true });
              this.router.navigate([URLAFTERTEAMS]);

            },
            error => {
              if (error == "Bad Request")
                error = "Authentication Failed Due To Server Down";
              else if (error == "Forbidden")
                error = "User needs admin rights to connect teams";
              else if (error == "Conflict")
                error = "Application is already installed on the Teams catalog";

              localStorage.clear();
              this.spinner.hide();
              this.alertService.error(error, { keepAfterRouteChange: true });
              const url="./connection/automation/"+this.user.uId;
              this.router.navigate([url]);
            })

      });

    }
    else {
      this.Dashboard = "Dashboard";
      localStorage.removeItem('IsPublish');
    }


  }
}
